import {useEffect, useRef} from 'react'
import {triggerScrollDepthEvent} from '../utills/gtm/triggerScrollDepthEvent'
import {THRESHOLDS} from '../constants'

export const useScrollDepthTracking = (enabled = true) => {
    const firedRef = useRef(new Set())

    useEffect(() => {
        if (!enabled || typeof window === 'undefined') {
            return
        }
        firedRef.current = new Set()

        const evaluate = () => {
            const doc = document.documentElement
            if (!doc) return
            const scrollable = doc.scrollHeight - window.innerHeight
            if (scrollable <= 0) return
            const percent = ((window.scrollY || doc.scrollTop) / scrollable) * 100

            THRESHOLDS.forEach((threshold) => {
                if (percent >= threshold && !firedRef.current.has(threshold)) {
                    firedRef.current.add(threshold)
                    triggerScrollDepthEvent(threshold)
                }
            })
        }

        let ticking = false
        const onScroll = () => {
            if (ticking) return
            ticking = true
            window.requestAnimationFrame(() => {
                evaluate()
                ticking = false
            })
        }

        window.addEventListener('scroll', onScroll, {passive: true})
        evaluate()

        return () => window.removeEventListener('scroll', onScroll)
    }, [enabled])
}
